// FirePlace
// Features:
// - Mesh with custom shader material (ambient + point light)
// - Contains the Fire particle system
// - Emits fire sound

import { useMemo } from 'react'
import * as THREE from 'three'

import vertexShaderInside from '../shaders/fireplace/vertex.glsl'
import fragmentShaderInside from '../shaders/fireplace/fragment.glsl'

import Fire from './Fire'
import RoomSound from './RoomSound'

const FIREPLACE_CONFIG = {
    p1Pos: new THREE.Vector3(-2.17, 0.89, -3.01),
    p1Color: new THREE.Color('#ff7300'),
    p1Intensity: 11,
    p1Decay: 0.47,
    pSpecularPower: 1.0,
    ambientColor: new THREE.Color('#ffe3b9'),
    ambientIntensity: 0.74,
}

export default function FirePlace({ nodes, texture }) {
    // Materials
    const material = useMemo(() => {
        return new THREE.ShaderMaterial({
            uniforms: {
                uColor: new THREE.Uniform(new THREE.Color('#ff0000')), // Base tint if needed
                uMap: { value: texture },
                uIntensity: { value: FIREPLACE_CONFIG.ambientIntensity },
                uAmbientColor: { value: FIREPLACE_CONFIG.ambientColor },

                // Point Light 1
                uPointLight1Position: { value: FIREPLACE_CONFIG.p1Pos },
                uPointLight1Color: { value: FIREPLACE_CONFIG.p1Color },
                uPointLight1Intensity: { value: FIREPLACE_CONFIG.p1Intensity },
                uPointLight1Decay: { value: FIREPLACE_CONFIG.p1Decay },

                // Common parameters
                uPointLightSpecularPower: {
                    value: FIREPLACE_CONFIG.pSpecularPower,
                },
            },
            vertexShader: vertexShaderInside,
            fragmentShader: fragmentShaderInside,
        })
    }, [texture])

    return (
        <group>
            <mesh geometry={nodes.fireplace.geometry} material={material} />
            <Fire />
            <RoomSound
                url="/sounds/fire.mp3"
                volume={0.4}
                position={[-2.17, 0.61, -3.03]}
            />
        </group>
    )
}
